import snarkdown from 'snarkdown';
import state from '@/state';

function strip(html) {
  // @TODO vi kikar på hur vi kan göra detta ordentligt och lägger i utils
  return html.replace(/</g, '&lt;');
}

function md (str) {
  if (!str)
    return str;

  if (state.phraseFinderMode) {
    return str;
  }
  
  str = strip(str).replace(/\n\n-/g, "\n-"); // @TODO remove this ugly hack needed between versions
  
  return snarkdown(str)
  .replaceAll('<h1>',   '<h2 class="gmf-subheader">')
  .replaceAll('</h1>',   '</h2>')
  .replaceAll('<a', '<a class="gmf-link"');
}

export default md;
